// HomeScreen.tsx — 솟다 통합 홈 v5 (행동 주인공 IA)
// 시안: mockups/sotda-home/sotda-home-v5.html · design doc docs/specs/2026-06-01-sotda-creator-retention-design.md §8
// IA 6블록: ① 오늘의 솟다(행동·히어로) → ② 총자산(다이버징) → ③ 시황 + 오늘의 한 수 → ④ 콘텐츠
// 설계 원칙(design.md §proportion): 60-30-10(히어로만 accent 주인공) · 황금비 61.8:38.2 · 8pt · 타입스케일 11/13/16/24
// 실데이터(props): hero.total/diff · market[] · sentiment(CNN 공포탐욕·VIX 실시간 fetch)  /  신규 블록(챌린지·BULL·월급·실패박물관)은 시안 정적값(후속 배선)
// @ts-nocheck
import '../cs-tokens.css';
import HomeHabitHero from './HomeHabitHero.tsx';
import { CSCard, CSAppBar, CSAvatar, CSIconBtn, CSIcon, CSAreaChart, BullCoin } from '../_components/cs';
import { CastAvatar, CAST } from '../_components/cast';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../lib/api';
import { useActiveMacroEvents, pickPrimaryEvent } from '../../hooks/useMacroEvents';
import { cachedFetch, peekCache } from '../../lib/prefetch';
import { supabase } from '../../lib/supabase';
import { formatPostDate } from '@core/community/communityMeta';
// 축약 원화 표기 정본(만·억) — K/M 표기는 2026-07-24 폐기 결정. diff도 같은 규칙을 따른다.
import { formatKRWShort } from '@core/util/format';
import { attachLevels } from '../../data-access/authorLevelsAdapter';
import { useAuth } from '../../lib/useAuth';
import { openExternal, TERMS_URL, PRIVACY_URL, REFUND_URL, RATES_URL } from '../../lib/externalLink';
import { SupportSheet } from './SupportSheet';
import { RollingNumber } from '../_components/RollingNumber';
import { subscribeMiniTickers } from '../../data-access/binanceWs';
import { subscribeYahooTicks } from '../../data-access/yahooWs';
import { applyLivePrice } from '@core/sim/market/liveParsers';
import { Preferences } from '@capacitor/preferences';
import { resolveSymbolName } from '../../lib/symbolName';
import { buildBullIntraday, bucketBullSeries } from '@core/sim/market/bullSeries';
import { extractUnreflectedLossCards } from '@core/sim/behavior/behaviorEngine'; // 복기 대기 손실 건수 — 히어로 빈화면 진입 차단
import { CHALLENGE_TRACKS, DEFAULT_TRACK } from '@core/economy/challengeTracks';
import { useMyChallenge } from '../../hooks/useChallenge'; // 행동 챌린지(6엔진 Step 6) — 히어로 동적 게이지
import { fetchWeeklyPopularIndicator } from '../../data-access/indicatorGallerySupabase';
import { IndicatorGalleryCard } from './IndicatorGalleryList';
import { useEquippedCompanion } from '../../hooks/useEquippedCompanion';
import { BotAuthorAvatar, EquippedCosmeticMini } from '../_components/SocialCosmetic';
import { companionLine } from '../companion/companionVoice';
import { POST_COLUMNS } from '@core/community/columns';

function todayLabel() {
  const t = new Date();
  const dow = ["일", "월", "화", "수", "목", "금", "토"][t.getDay()];
  return `${t.getMonth() + 1}월 ${t.getDate()}일 (${dow})`;
}

function companionTimeVars(now = new Date()) {
  const hour = now.getHours();
  const timeGreeting = hour < 6 ? '고요한 새벽이야' : hour < 12 ? '좋은 아침이야' : hour < 18 ? '좋은 오후야' : '편안한 저녁이야';
  const dayMood = ['일요일의 여유', '월요일의 새 출발', '화요일의 리듬', '수요일의 중심', '목요일의 호흡', '금요일의 마무리', '토요일의 여유'][now.getDay()];
  return { timeGreeting, dayMood };
}

function homeExcerpt(c) {
  if (!c) return '';
  return String(c).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 60);
}

/* 🐂 BULL 전용 차트 — CSAreaChart 재사용(play 곡선과 동일 컴포넌트)으로 교체.
   구 12칸 자리표시 SVG는 씨앗 단계(스냅샷 소수)에서 왼쪽에 몰려 비어 보이고 y축 기준점도
   없었음(효신님 SE3 육안 2026-07-02) → 데이터가 몇 개든 전폭 사용 + y축 눈금 3단 자동.
   단위 사다리 진행(n/12)은 차트 위 텍스트 라벨이 계속 전달. */
function BullChart({ series }) {
  if (!series || series.length < 2) return null;
  return (
    <div style={{ marginTop: 4 }}>
      <CSAreaChart data={series} h={140} color="var(--cs-gold)" labels={['과거', '현재']} />
    </div>
  );
}

/* ── CNN 공포·탐욕 5구간 — 청회↔녹 저채도 발산(디자이너 3인 합의·강조中, 2026-06-09).
      공포=차가운 청회(한기) → 중립 mute → 탐욕=income 녹. 채도 V곡선(양극 또렷·중립 바램).
      cs-tokens 정식 토큰(--cs-fg-*, 시황 게이지 전용 격리)만 사용.
      ⚠ 폐기 이력: 적갈(팔레트 미정의)·고채도 파랑 청록축(60-30-10 위반) — 효신님 지적. ── */
const FG_SEGMENTS = [
  { start: 0,  end: 25,  color: "var(--cs-fg-xfear)",   word: "극공포" },
  { start: 25, end: 45,  color: "var(--cs-fg-fear)",    word: "공포"   },
  { start: 45, end: 55,  color: "var(--cs-fg-neutral)", word: "중립"   },
  { start: 55, end: 75,  color: "var(--cs-fg-greed)",   word: "탐욕"   },
  { start: 75, end: 100, color: "var(--cs-fg-xgreed)",  word: "극탐욕" },
];
function fgWhich(v) {
  return FG_SEGMENTS.find(s => v >= s.start && v <= s.end) || FG_SEGMENTS[2];
}

/* ── SVG 5구간 호 게이지 + 호 안쪽 화살표 (sweep-flag 0→1 호 뒤집힘 수정 · D2 마커 채택 2026-06-02) ── */
function FearGreedGauge({ value = 62, size = 220, arrowDepth = 4 }) {
  const w = size, h = Math.round(size * 0.58);
  const cx = w / 2, cy = h - 8;
  const rOuter = Math.round(w * 0.46);
  const ringWidth = Math.max(14, Math.round(w * 0.11)); // 작은 size 대응 (원본 하한 28→14)
  const rMid = rOuter - ringWidth / 2;
  const rInner = rOuter - ringWidth;
  const toAng = (v) => Math.PI * (1 - v / 100);
  const point = (v, rr) => [cx + rr * Math.cos(toAng(v)), cy - rr * Math.sin(toAng(v))];
  const arcPath = (vs, ve, rr) => {
    const [x1, y1] = point(vs, rr);
    const [x2, y2] = point(ve, rr);
    const large = (ve - vs) > 50 ? 1 : 0;
    // sweep-flag=1 — 위로 볼록 ∩ (원본은 0이라 양끝이 아래로 말려 "뒤집힘"으로 보였음)
    return `M ${x1.toFixed(2)} ${y1.toFixed(2)} A ${rr} ${rr} 0 ${large} 1 ${x2.toFixed(2)} ${y2.toFixed(2)}`;
  };
  // 호 안쪽 화살표 — 중심 바늘 대신, 호 안쪽에서 현재값을 가리킴 (숫자 안 가림 · 수치 따라 이동)
  const [tx, ty] = point(value, rInner - arrowDepth);
  const [b1x, b1y] = point(value - 4, rInner - arrowDepth - 9);
  const [b2x, b2y] = point(value + 4, rInner - arrowDepth - 9);
  return (
    <svg width={w} height={h + 6} viewBox={`0 0 ${w} ${h + 6}`} style={{ display: "block", margin: "0 auto" }}>
      {FG_SEGMENTS.map((s, i) => (
        <path key={i} d={arcPath(s.start, s.end, rMid)}
              stroke={s.color} strokeWidth={ringWidth} fill="none" strokeLinecap="butt" />
      ))}
      <polygon points={`${tx.toFixed(1)},${ty.toFixed(1)} ${b1x.toFixed(1)},${b1y.toFixed(1)} ${b2x.toFixed(1)},${b2y.toFixed(1)}`} fill="var(--cs-ink)" />
    </svg>
  );
}

/* ── 섹션 헤더 ── */
function SectH({ title, eye, link = "전체 →", onEye, eyeOn, onLink }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 4px 8px" }}>
      <h3 style={{ fontSize: 13, fontWeight: 800, margin: 0, display: "flex", alignItems: "center", gap: 6 }}>
        {title}{eye && <span onClick={onEye} style={{ fontSize: 11, color: "var(--cs-mute)", cursor: "pointer", userSelect: "none", display: "inline-flex", alignItems: "center", gap: 3 }}><CSIcon name={eyeOn ? "lock" : "eye"} size={12} />비공개</span>}
      </h3>
      {link && <a href="#" onClick={(e) => { e.preventDefault(); onLink?.(); }} style={{ fontSize: 11, color: "var(--cs-mute)", textDecoration: "none" }}>{link}</a>}
    </div>
  );
}

/* 푸터 (compact) */
// 링크 1개 — <a>로 시맨틱은 유지하되 실제 이동은 openExternal이 맡는다.
// (앱은 로컬 번들이라 앵커의 기본 이동을 그대로 두면 웹뷰가 앱을 떠나버린다. externalLink.ts 주석 참고)
function FooterLink({ label, style, onOpen }) {
  return (
    <a
      href="#"
      onClick={(e) => { e.preventDefault(); onOpen(); }}
      style={{ ...style, textDecoration: "none" }}
    >
      {label}
    </a>
  );
}

function HomeFooter() {
  const linkStyle = { fontSize: 11, color: "var(--cs-ink-2)", cursor: "pointer" };
  const [supportOpen, setSupportOpen] = useState(false);
  return (
    <footer style={{ marginTop: 24, padding: "20px 4px 16px", boxShadow: "inset 0 1px 0 var(--cs-line)" }}>
      <div className="cs-italic" style={{ fontSize: 20, letterSpacing: "-0.02em" }}>솟다</div>
      <div style={{ fontSize: 11.5, color: "var(--cs-mute)", marginTop: 6, lineHeight: 1.65 }}>
        sotda.com · 머니타운 IP<br />모든 시세는 15분 지연 · 참고용
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 16px", marginTop: 16, fontWeight: 500 }}>
        {/* 개인정보처리방침 접근성은 앱스토어 심사 필수 항목 — 표시만 하지 말고 반드시 실제로 열려야 한다 */}
        <FooterLink label="이용약관" style={linkStyle} onOpen={() => openExternal(TERMS_URL)} />
        <FooterLink label="개인정보처리방침" style={linkStyle} onOpen={() => openExternal(PRIVACY_URL)} />
        {/* 환불규정 = 웹 /refund. 유상 재화(충전 BULL·구독) 결제 표면이 있는 이상 청약철회·환불 조건은
            앱에서도 도달 가능해야 한다 (전자상거래법 제17조). 라벨은 웹 페이지 제목과 동일하게 "환불규정" */}
        <FooterLink label="환불규정" style={linkStyle} onOpen={() => openExternal(REFUND_URL)} />
        {/* 고객지원 = 문의 시트(메일 앱 열기 + 주소 복사). 웹 /support는 서포터(구독) 랜딩이라 고객지원 경로가 아니다.
            공지사항은 웹에 해당 페이지가 없어 죽은 링크 대신 항목을 제거했다 (페이지 생기면 복원) */}
        <FooterLink label="고객지원" style={linkStyle} onOpen={() => setSupportOpen(true)} />
        {/* 확률 공개 = 웹 /rates. 게임산업법 제33조 제2항은 "인터넷 홈페이지 및 광고·선전물마다" 표시를 요구하고,
            앱 안 모달만으로는 그 요건도, 심사자에게 제시할 URL도 못 채운다. */}
        <FooterLink label="확률 공개" style={linkStyle} onOpen={() => openExternal(RATES_URL)} />
      </div>
      <div style={{ marginTop: 16, paddingTop: 12, boxShadow: "inset 0 1px 0 var(--cs-line)",
                    fontSize: 10.5, color: "var(--cs-mute)", fontFamily: "var(--cs-font-mono)" }}>
        © 2026 sotda.com · all rights reserved
      </div>
      <SupportSheet open={supportOpen} onClose={() => setSupportOpen(false)} />
    </footer>
  );
}

/* ─────────────────────────────────────────────────────────────
   SotdaHomeScreen — 솟다 통합 홈 v5
   props.data = HomePageData (mobile/src/types/home.ts)
   ───────────────────────────────────────────────────────────── */
export function SotdaHomeScreen({ data = {} }) {
  const nav = useNavigate(); // 실패박물관 블록 배선 (2026-06-10 — 진입 갭 해소)
  // 거시 이벤트방(6엔진 Step 4) — 활성 이벤트 있을 때만 시황 아래 위젯 노출(토글 OFF면 [] → 숨김)
  const macroPrimary = pickPrimaryEvent(useActiveMacroEvents());
  const { user } = useAuth();
  const companion = useEquippedCompanion(['home_mascot', 'nick_avatar']);
  const nick = user?.nickname || user?.name || ''; // 히어로 화자/환영 보간 (없으면 폴백)
  const [assetHidden, setAssetHidden] = useState(false);
  // 행동 챌린지(6엔진 Step 6) — 내 진행. null=미참가(참가 CTA), active=게이지(D+N/7), 결말=배지/재도전
  const { challenge, loading: challengeLoading, error: challengeError, eligibility, refresh: refreshChallenge, join: joinChallenge } = useMyChallenge();
  const [joining, setJoining] = useState(false);
  const [popularIndicator, setPopularIndicator] = useState(null);
  useEffect(() => { fetchWeeklyPopularIndicator().then(setPopularIndicator).catch(() => {}); }, []);

  // 홈 봇 뉴스 — 커뮤니티 최신 봇글 1개 연동 (봇글 올라가면 홈도 같이 갱신)
  const [botPost, setBotPost] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data: rows } = await supabase.from('community_posts')
          .select(POST_COLUMNS).order('created_at', { ascending: false }).limit(12);
        const enriched = await attachLevels(rows || []);
        // 홈 봇 뉴스 = 황둥이(정기글) 최신 우선, 없으면 아무 봇글
        const bot = enriched.find((p) => p.author_is_bot && p.author_bot_persona !== 'event')
          || enriched.find((p) => p.author_is_bot);
        if (alive) setBotPost(bot || null);
      } catch (e) { /* 실패 시 폴백 카드 유지 */ }
    })();
    return () => { alive = false; };
  }, []);

  // ② BULL 자산 연동 (A+B 채택 2026-06-13) — 비로그인·계좌 없음은 catch로 BULL 줄 숨김.
  //   B: 총자산 아래 BULL 숫자 그대로(비율 X·효신님 지정) + 실시간 롤링 / A: 차트 골드 추세 라인(스냅샷 시계열).
  const [simPf, setSimPf] = useState(() => peekCache('/api/mobile/sim/portfolio?league=swing')); // 캐시 hit 시 즉시(#1·#5)
  const [bullSnaps, setBullSnaps] = useState(null);
  const [lossCount, setLossCount] = useState(0); // 복기 대기 손실 매도 건수 (히어로 복기 입구 조건부 노출)
  const [triggeredAlerts, setTriggeredAlerts] = useState(null); // 도달한 가격 알림 수 (null=모름/미로그인 → 점 없음)
  useEffect(() => {
    let alive = true;
    cachedFetch('/api/mobile/sim/portfolio?league=swing', { cache: 'no-store' })
      .then((d) => { if (alive && d?.total_value_bull != null) setSimPf(d); })
      .catch(() => {});
    apiFetch('/api/mobile/sim/history?league=swing', { cache: 'no-store' })
      .then((d) => {
        if (alive && d?.snapshots?.length) {
          setBullSnaps(d.snapshots.map((s) => ({ t: Math.floor(Date.parse(s.date) / 1000), v: Number(s.total_value_bull) })));
        }
      })
      .catch(() => {});
    // 복기 대기 손실 건수 (SimScreen.loadLoss 패턴 재사용) — 손실 0건이면 히어로 복기 입구 숨김
    apiFetch('/api/mobile/sim/trades?league=swing&limit=300', { cache: 'no-store' })
      .then((t) => { if (alive) setLossCount(extractUnreflectedLossCards(t?.trades || []).length); })
      .catch(() => {});
    // 🔔 도달한 가격 알림 건수 (2026-08-02) — 헤더 벨의 점.
    //   쪽지 적재를 끊으면서 벨 뱃지(messages 기반)의 통지 역할을 이 점이 대신 받는다.
    //   푸시를 끈 알림도 여기서는 보인다 = 통지 표면이 푸시 하나로 줄지 않게 하는 장치.
    //   실패는 0으로 두지 않고 null로 남긴다(점을 안 그림) — 조회 실패를 "도달 없음"으로 위장하지 않기 위해.
    if (user) {
      apiFetch('/api/mobile/sim/alerts', { cache: 'no-store' })
        .then((r) => { if (alive) setTriggeredAlerts((r?.alerts || []).filter((a) => a.status === 'triggered').length); })
        .catch(() => { if (alive) setTriggeredAlerts(null); });
    } else if (alive) setTriggeredAlerts(null);
    return () => { alive = false; };
  }, [user?.id]); // 로그인 시 user 바뀌면 홈 개인 데이터 재조회 (5번 2026-06-24 — deps [] → 세션 변화 무반응 버그)
  // 실시간 — SimScreen과 동일 패턴 (보유 코인 miniTicker + 주식 Yahoo 틱 → applyLivePrice 델타)
  const homeCrypto = (simPf?.positions || []).map((p) => p.symbol).filter((s) => /-USD$/.test(s)).sort().join(',');
  useEffect(() => {
    if (!homeCrypto) return;
    const unsub = subscribeMiniTickers(homeCrypto.split(','), (sym, price) => {
      if (document.visibilityState !== 'visible') return;
      setSimPf((prev) => (prev ? applyLivePrice(prev, sym, price) : prev));
    });
    return unsub;
  }, [homeCrypto]);
  const homeStock = (simPf?.positions || []).map((p) => p.symbol).filter((s) => !/-USD$/.test(s)).sort().join(',');
  useEffect(() => {
    if (!homeStock) return;
    const unsub = subscribeYahooTicks(homeStock.split(','), (tk) => {
      if (document.visibilityState !== 'visible') return;
      setSimPf((prev) => (prev ? applyLivePrice(prev, tk.id, tk.price) : prev));
    });
    return unsub;
  }, [homeStock]);

  const bullTotal = simPf?.total_value_bull; // ⚠ bullPicked IIFE보다 먼저 선언 (TDZ 방지 — 2026-06-13 흰화면 사고)
  // 신규유저(거래0·BULL0) — 포트폴리오 로드 후에만 판정(로딩 중 깜빡임 방지). 콜드스타트 분기용 (감사 ⑤)
  const isNewbie = simPf != null && !(simPf.positions?.length) && !(Number(bullTotal) > 0);

  // 인트라데이 5분 역산 (최근 5일) — 12칸 사다리의 5분~4시간 단계 소스.
  // ⚠ deps는 심볼 목록 문자열 — simPf는 WS 틱마다 갱신되므로 직접 넣으면 ohlcv 호출 폭주
  const [intraday, setIntraday] = useState(null);
  const allPosSyms = (simPf?.positions || []).map((p) => p.symbol).sort().join(',');
  useEffect(() => {
    if (!allPosSyms) { setIntraday(null); return; }
    let alive = true;
    setSimPf((cur) => { // 클로저 stale 회피 — 현재 상태 기준으로 fetch (값은 그대로 반환)
      const ps = cur?.positions || [];
      Promise.all(ps.map((p) =>
        apiFetch(`/api/market/ohlcv?symbol=${encodeURIComponent(p.symbol)}&range=5d&interval=5m`)
          .then((r) => [p.symbol, r?.candles || []]).catch(() => [p.symbol, []])))
        .then((entries) => {
          if (!alive || !cur) return;
          const cash = Math.max(0, Number(cur.total_value_bull) - Number(cur.holdings_value_bull || 0));
          setIntraday(buildBullIntraday(ps, Object.fromEntries(entries), cash));
        });
      return cur;
    });
    return () => { alive = false; };
  }, [allPosSyms]);
  // 12칸 bucket — anchor = 계좌 개설(가입) 시각. 포인트 풀 = 인트라데이(5d·5분) + 일별 스냅샷 + 실시간 현재값
  const bullPicked = (() => {
    if (bullTotal == null) return null;
    const now = Math.floor(Date.now() / 1000);
    const pts = [...(intraday || []), ...(bullSnaps || []), { t: now, v: bullTotal }];
    const anchor = simPf?.account?.created_at
      ? Math.floor(Date.parse(simPf.account.created_at) / 1000)
      : pts[0].t;
    return bucketBullSeries(pts, Math.min(anchor, now), now);
  })();
  const bullSeries = bullPicked?.values || null;
  // 스왑 뷰 (효신님 2026-06-13: "섞지 말고 스왑") — 선택 기억 + 비공개 시 BULL 뷰 자동 대체(빈 blur보다 의미 있는 화면)
  const [assetView, setAssetView] = useState('real');
  const [viewPicked, setViewPicked] = useState(false); // 유저가 직접 뷰를 골랐나 (신규 기본 BULL 뷰가 수동 선택을 덮지 않게)
  useEffect(() => {
    Preferences.get({ key: 'sotda-asset-view' }).then((r) => { if (r.value) { setAssetView(r.value); setViewPicked(true); } }).catch(() => {});
  }, []);
  // 같은 세그먼트 재클릭 = 반대로 토글 (효신님 — 한 손가락 왕복 전환)
  const pickView = (v) => {
    const next = v === effView ? (v === 'real' ? 'bull' : 'real') : v;
    setAssetView(next); setViewPicked(true);
    Preferences.set({ key: 'sotda-asset-view', value: next }).catch(() => {});
  };
  // 신규유저는 기본 BULL 뷰(실자산 0이라 BULL이 더 의미 있음) — 단 유저가 직접 고르면 그 선택 우선
  const effView = viewPicked ? assetView : (isNewbie ? 'bull' : assetView);
  const showBullView = bullTotal != null && (assetHidden || effView === 'bull');
  const bullPct = simPf?.pnl_pct ?? 0;
  // 오늘 BULL 변동 = 현재(실시간) − 마지막 일별 스냅샷(전일 마감). 스냅샷 없으면 보유 평가손익으로 폴백
  const bullToday = bullTotal != null
    ? (bullSnaps?.length ? bullTotal - bullSnaps[bullSnaps.length - 1].v : Number(simPf?.pnl_bull || 0))
    : null;

  // ③ 시황 지수 6칸 실시간 — quote 30s 폴링(서버 공유 캐시) + 슬롯 롤링. matview 스냅샷(data.market)은 첫 페인트 fallback.
  //   포맷·심볼 실측 2026-06-13: ^TNX=4.487(% 그대로·등락은 포인트 차), 그 외 지수는 % 등락.
  const [liveIdx, setLiveIdx] = useState(null);
  useEffect(() => {
    let alive = true;
    const SYMS = [
      { sym: '^GSPC', name: 'S&P500', fmt: (p) => Math.round(p).toLocaleString('ko-KR') },
      { sym: '^IXIC', name: '나스닥', fmt: (p) => Math.round(p).toLocaleString('ko-KR') },
      { sym: '^KS11', name: '코스피', fmt: (p) => p.toLocaleString('ko-KR', { maximumFractionDigits: 0 }) },
      { sym: '^TNX', name: '미국채10Y', fmt: (p) => p.toFixed(2) + '%', pt: true },
      { sym: 'GC=F', name: '금', fmt: (p) => Math.round(p).toLocaleString('ko-KR') },
      { sym: 'BTC-USD', name: '비트코인', fmt: (p) => '$' + (p / 1000).toFixed(1) + 'K' },
    ];
    const loadIdx = async () => {
      const rs = await Promise.all(SYMS.map((d) =>
        apiFetch(`/api/market/quote?symbol=${encodeURIComponent(d.sym)}`).catch(() => null)));
      if (!alive) return;
      const rows = rs.map((q, i) => {
        if (!q?.price) return null;
        const d = SYMS[i];
        const chg = d.pt ? q.price - (q.prevClose ?? q.price)
          : q.prevClose ? (q.price / q.prevClose - 1) * 100 : 0;
        return { name: d.name, v: d.fmt(q.price), c: (chg >= 0 ? '+' : '') + chg.toFixed(2) + (d.pt ? '' : '%'), up: chg >= 0 };
      }).filter(Boolean);
      if (rows.length >= 3) setLiveIdx(rows);
    };
    loadIdx();
    const iv = setInterval(() => { if (document.visibilityState === 'visible') loadIdx(); }, 30000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  // ③ 시황 실시간 심리 — CNN 공포·탐욕(0~100) + Yahoo VIX. 60s 폴링 (실패 시 직전/시안 fallback 유지).
  const [sentiment, setSentiment] = useState(null);
  useEffect(() => {
    let alive = true;
    const loadSent = () => apiFetch('/api/market/sentiment').then((d) => { if (alive) setSentiment(d); }).catch(() => {});
    loadSent();
    const iv = setInterval(() => { if (document.visibilityState === 'visible') loadSent(); }, 60000);
    return () => { alive = false; clearInterval(iv); };
  }, []);
  const fgVal = sentiment?.fearGreed?.value ?? 62;
  const vixVal = sentiment?.vix?.value ?? 18.5;
  const vixLevel = vixVal < 15 ? { t: '낮음 · 안정', c: 'var(--cs-income)' }
    : vixVal < 20 ? { t: '보통', c: 'var(--cs-mute)' }
    : vixVal < 30 ? { t: '높음 · 주의', c: 'var(--cs-fall)' }
    : { t: '매우 높음 · 불안', c: 'var(--cs-fall)' };

  const fmt = (n) => "₩" + Number(n || 0).toLocaleString("ko-KR");
  const hero = data.hero || {};
  // ② 실자산 배선(2026-06-03): 총자산 = 솟다앱에 입력한 자산 총합(hero.total = SUM user_asset_items).
  //   입력 0건이면 ₩0 (효신님 정의: 솟다앱 입력 자산만 집계, 증권 거래내역은 별도 섹션이라 미합산).
  const total = Number(hero.total || 0);
  // 1년 변동 — 서버(home route)가 히스토리 스냅샷 부재로 항상 0을 준다. 과거 `|| 21000000` 더미 폴백이
  // 모든 유저에게 "▲21M"를 영구 표시하던 것을 폐기(2026-08-12). 0이면 라벨 자체를 숨긴다.
  const diff = Number(hero.diffAmount || 0);
  // 구성비 실데이터 우선 — allocation.slices 있으면 동적 렌더, 없으면(0건) 아래 더미 4칸 fallback(빈 막대 방지)
  const alloc = data.allocation || {};
  const allocSlices = (alloc.slices && alloc.slices.length > 0) ? alloc.slices : null;

  // 시황 지수 6칸 — 실데이터(market) 우선, 없으면 시안 fallback
  const IDX_FALLBACK = [
    { name: "S&P500", v: "5,720", c: "+0.83%", up: true },
    { name: "나스닥", v: "18,820", c: "+1.24%", up: true },
    { name: "코스피", v: "2,742", c: "-0.41%", up: false },
    { name: "미국채10Y", v: "4.21%", c: "+0.03", up: true },
    { name: "금", v: "2,680", c: "+0.5%", up: true },
    { name: "비트코인", v: "$62.4K", c: "+2.1%", up: true },
  ];
  // 우선순위: 실시간(liveIdx 30s 폴링) → matview 스냅샷(data.market) → 시안 fallback
  const idx = liveIdx || ((data.market && data.market.length >= 3)
    ? data.market.slice(0, 6).map((tk) => {
        const pct = Number(tk.changePct || 0);
        return { name: tk.name, v: tk.value, c: (pct >= 0 ? "+" : "") + pct + "%", up: pct >= 0 };
      })
    : IDX_FALLBACK);

  // 장착 캐릭터가 오늘의 화자다. 날짜 seed로 고정하고 시간대·요일만 정적 토큰으로 보간한다.
  const chTrack = CHALLENGE_TRACKS[challenge?.track || DEFAULT_TRACK];
  const now = new Date();
  const homeLine = companionLine(companion.slug, companion.grade, 'home', now.getDate(), companionTimeVars(now));

  return (
    <div className="cs-root" data-density="regular" data-temp="warm" data-heading="serif"
         style={{ width: "100%", minHeight: "100%", position: "relative", background: "var(--cs-bg)" }}>
      <CSAppBar
        left={<CSAvatar name={nick || "투자자"} size={32} tone="ink" />}
        title={<span className="cs-italic" style={{ fontSize: 17 }}>솟다</span>}
        right={<>
          <span style={{ fontSize: 11, color: "var(--cs-mute)", marginRight: 6 }}>{todayLabel()}</span>
          {/* 🔴 2026-08-02: 여태 onClick이 없어 **눌러도 아무 일도 안 나던 데드 버튼**이었다.
              가격 알림(/alerts)으로 연결 — 쪽지 적재를 끊었으므로 도달의 정본이 그 화면이다.
              점은 MY 헤더 벨과 같은 표현(숫자 없이 accent 점). */}
          <CSIconBtn label={triggeredAlerts ? `가격 알림 · ${triggeredAlerts}건 도달` : '가격 알림'} onClick={() => nav('/alerts')}>
            <span style={{ position: 'relative', display: 'inline-flex' }}>
              <CSIcon name="bell" />
              {triggeredAlerts > 0 && (
                <span aria-hidden style={{ position: 'absolute', top: -2, right: -3, width: 7, height: 7, borderRadius: 'var(--cs-r-pill)', background: 'var(--cs-accent)' }} />
              )}
            </span>
          </CSIconBtn>
        </>}
      />

      <div className="cs-stagger" style={{ padding: "0 16px 24px" }}>

        <HomeHabitHero
          challenge={challenge} challengeLoading={challengeLoading} challengeError={challengeError}
          eligibility={eligibility} refreshChallenge={refreshChallenge} joinChallenge={joinChallenge}
          lossCount={lossCount}
        />

        {/* ② 총자산 (차분한 카드 — accent 아님) */}
        <SectH title={<>총자산</>} eye eyeOn={assetHidden} onEye={() => setAssetHidden((v) => !v)} />
        <CSCard padded style={{ marginBottom: 16 }}>
          {/* 스왑 세그먼트 (효신님 2026-06-13) — 비공개 중엔 BULL 강제라 숨김. BULL 계좌 없으면 미노출 */}
          {bullTotal != null && !assetHidden && (
            <div style={{ display: "inline-flex", background: "var(--cs-surface-2)", borderRadius: 999, padding: 2, marginBottom: 10 }}>
              {/* T3 배칭E — BULL 세그먼트 라벨의 🐂 를 코인 아이콘(b안)으로 */}
              {[{ k: 'real', label: <>₩ 실자산</> }, { k: 'bull', label: <><BullCoin size={11} style={{ marginRight: 3 }} />BULL</> }].map((o) => (
                <button key={o.k} onClick={() => pickView(o.k)}
                  style={{ border: 0, cursor: "pointer", borderRadius: 999, padding: "5px 12px", fontSize: 11.5, fontWeight: 700,
                    background: effView === o.k ? "var(--cs-surface)" : "transparent",
                    color: effView === o.k ? (o.k === 'bull' ? "var(--cs-gold)" : "var(--cs-ink)") : "var(--cs-mute)",
                    boxShadow: effView === o.k ? "0 1px 3px rgba(0,0,0,.08)" : "none" }}>
                  {o.label}
                </button>
              ))}
            </div>
          )}
          {showBullView ? (<>
            {/* ── 🐂 BULL 뷰 — 가상자산이라 비공개 부담 없음 (실시간 슬롯 롤링) ── */}
            <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
              <span className="num" style={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.02em", color: "var(--cs-gold)", fontFamily: "var(--cs-font-mono)" }}>
                <RollingNumber text={Math.round(bullTotal).toLocaleString("ko-KR")} />
              </span>
              <span style={{ fontSize: 12, color: "var(--cs-mute)", fontWeight: 700 }}>BULL</span>
              {/* "모의" 상시 칩 — 신규 유저 실자산 혼동 방지 (②설계 Q2 · 2026-07-02) */}
              <span style={{ fontSize: 9.5, fontWeight: 700, color: "var(--cs-gold)", background: "var(--cs-gold-soft)", borderRadius: 5, padding: "2px 5px" }}>모의</span>
              <span className="num" style={{ fontSize: 12, fontWeight: 700, color: bullPct >= 0 ? "var(--cs-rise)" : "var(--cs-fall)" }}>
                <RollingNumber text={(bullPct >= 0 ? "+" : "") + bullPct.toFixed(2) + "%"} />
              </span>
            </div>
            {assetHidden && (
              <div style={{ fontSize: 10.5, color: "var(--cs-mute)", marginTop: 4, display: "inline-flex", alignItems: "center", gap: 4 }}><CSIcon name="lock" size={11} />실자산 비공개 중 — BULL 자산으로 표시돼요</div>
            )}
            {/* 단위 사다리 라벨 — 5분→…→30일, 12칸 차면 자동 승급 (n/12 = 차오름 진행) */}
            {bullPicked && (
              <div style={{ textAlign: "right", fontSize: 9.5, color: "var(--cs-mute)", marginTop: 8 }}>
                {bullPicked.label} 기준 · {bullPicked.filled}/12
              </div>
            )}
            <BullChart series={bullSeries} />
            {/* 보유 구성 — 현금 + 포지션 비중 (골드 농도 단계) */}
            {(() => {
              const ps = simPf?.positions || [];
              const cash = Math.max(0, bullTotal - Number(simPf?.holdings_value_bull || 0));
              const segs = [
                { name: '현금', v: cash },
                ...ps.map((p) => ({ name: resolveSymbolName(p.symbol), v: Number(p.value_bull || 0) })),
              ].filter((s) => s.v > 0);
              const sum = segs.reduce((s, x) => s + x.v, 0) || 1;
              return (<>
                <div style={{ display: "flex", height: 8, borderRadius: 999, overflow: "hidden", marginTop: 16 }}>
                  {segs.map((s, i) => (
                    <i key={s.name} style={{ width: `${(s.v / sum) * 100}%`, background: "var(--cs-gold)", opacity: i === 0 ? 0.25 : Math.max(0.45, 1 - (i - 1) * 0.2) }} />
                  ))}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 14, marginTop: 6, fontSize: 11, color: "var(--cs-mute)" }}>
                  {segs.map((s) => (
                    <span key={s.name}>{s.name} <b style={{ color: "var(--cs-ink)" }}>{Math.round((s.v / sum) * 100)}%</b></span>
                  ))}
                </div>
              </>);
            })()}
            <button onClick={() => nav('/sim')} style={{ width: "100%", marginTop: 14, border: isNewbie ? "none" : "1px solid var(--cs-line)", background: isNewbie ? "var(--cs-accent)" : "var(--cs-surface)", color: isNewbie ? "var(--cs-accent-ink)" : "var(--cs-ink-2)", borderRadius: 10, padding: "10px 0", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>
              <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }}><CSIcon name="chart" size={14} />모의투자 {isNewbie ? '시작하기' : '운용하러 가기'}</span>
            </button>
          </>) : (<>
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <span className="num" onClick={() => assetHidden && setAssetHidden(false)} style={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.02em", filter: assetHidden ? "blur(9px)" : "none", userSelect: assetHidden ? "none" : "auto", cursor: assetHidden ? "pointer" : "default" }}>{fmt(total)}</span>
            {/* 기간 변동 — 서버 asset_snapshot_diff(7) 실값. 스냅샷이 그 기간을 못 덮으면 0이 와서 숨겨진다.
                (과거엔 더미 21M가 상시 노출됐다 — 2026-08-12 폐기 / 2026-08-14 실데이터 배선)
                기간 라벨은 서버가 준 diffPeriod를 쓴다. 예전엔 '(1년)' 하드코딩이라 서버 기준과 어긋났다. */}
            {diff !== 0 && (
              <span className="num" style={{ fontSize: 11, color: diff > 0 ? "var(--cs-income)" : "var(--cs-fall)", fontWeight: 700, marginLeft: 6, filter: assetHidden ? "blur(9px)" : "none" }}>
                {diff > 0 ? "▲" : "▼"} {formatKRWShort(Math.abs(diff))} ({hero.diffPeriod || "1주"})
              </span>
            )}
          </div>
          {/* 12개월 자산/부채 더미 차트(NW_SERIES)는 폐기 — 히스토리 스냅샷이 서버에 쌓이면 실차트로 복귀.
              지금은 실데이터인 구성비만 보여주고, 입력 0건이면 가짜 대신 입력 안내를 띄운다(2026-08-12). */}
          {allocSlices ? (<>
            <div style={{ display: "flex", height: 8, borderRadius: 999, overflow: "hidden", marginTop: 16 }}>
              {allocSlices.map((s) => (
                <i key={s.key} style={{ width: `${s.pct}%`, background: s.color }} />
              ))}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginTop: 6, fontSize: 11, color: "var(--cs-mute)" }}>
              {allocSlices.map((s) => (
                <span key={s.key}>{s.name} <b style={{ color: "var(--cs-ink)" }}>{s.pct}%</b></span>
              ))}
            </div>
          </>) : (
            <div style={{ marginTop: 16, padding: "18px 14px", background: "var(--cs-surface-2)", borderRadius: 12, textAlign: "center" }}>
              <div style={{ fontSize: 13, fontWeight: 700 }}>아직 입력한 자산이 없어요</div>
              <div style={{ fontSize: 11, color: "var(--cs-mute)", marginTop: 4 }}>자산을 입력하면 총자산과 구성이 여기에 표시돼요</div>
              <button onClick={() => nav('/asset')} style={{ marginTop: 12, border: "none", background: "var(--cs-accent)", color: "var(--cs-accent-ink)", borderRadius: 10, padding: "9px 16px", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>
                자산 입력하러 가기
              </button>
            </div>
          )}
          </>)}
        </CSCard>

        {/* ③ 오늘의 시황 */}
        <SectH title={<>오늘의 시황</>} />
        <CSCard padded style={{ marginBottom: 16 }}>
          {/* 공포탐욕 5구간 게이지 — 전체폭 + 숫자 반원 안 + 호 안쪽 화살표(D2) + VIX 한 줄
              간격 채택값(실제 화면 인라인 튜너 2026-06-02): arrowDepth 4 · paddingBottom 14 · 숫자 46 · 숫자-탐욕 -4 */}
          <div style={{ paddingBottom: 16, boxShadow: "inset 0 -1px 0 var(--cs-line)", marginBottom: 16 }}>
            <div style={{ position: "relative", width: 220, margin: "0 auto" }}>
              <FearGreedGauge value={fgVal} size={220} arrowDepth={4} />
              <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", paddingBottom: 14, pointerEvents: "none" }}>
                <div className="num" style={{ fontSize: 46, fontWeight: 800, lineHeight: 1, letterSpacing: "-0.05em", color: fgWhich(fgVal).color }}>{fgVal}</div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "var(--cs-ink)", marginTop: -4 }}>{fgWhich(fgVal).word}</div>
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 8, fontSize: 12, color: "var(--cs-mute)" }}>
              VIX 변동성 <b className="num" style={{ color: "var(--cs-ink)", fontWeight: 700 }}>{vixVal}</b>
              <span style={{ color: vixLevel.c, marginLeft: 4 }}>· {vixLevel.t}</span>
            </div>
            <div style={{ textAlign: "center", marginTop: 4, fontSize: 9.5, color: "var(--cs-mute)" }}>
              {sentiment?.source || "CNN 공포·탐욕 · Yahoo VIX (약 20분 지연)"}
            </div>
          </div>
          {/* 지수 6칸 (실데이터) */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
            {idx.map((x, i) => (
              <div key={x.name} style={{ background: "var(--cs-surface-2)", borderRadius: 8, padding: "7px 6px", textAlign: "center" }}>
                <div style={{ fontSize: 9.5, color: "var(--cs-mute)" }}>{x.name}</div>
                <div className="num" style={{ fontSize: 13, fontWeight: 800, marginTop: 1 }}><RollingNumber text={x.v} /></div>
                <div className="num" style={{ fontSize: 9.5, fontWeight: 700, color: x.up ? "var(--cs-rise)" : "var(--cs-fall)" }}><RollingNumber text={x.c} /></div>
              </div>
            ))}
          </div>
          {/* 시장 → 자산 연결 */}
          {/* 총자산 세그먼트와 연동 (효신님 2026-06-13) — BULL 뷰면 실데이터(오늘 시작 대비·실시간 롤링), 실자산 뷰면 추정(더미·배선 후속) */}
          <div style={{ margin: "16px 0", background: "var(--cs-gold-soft)", borderRadius: 10, padding: "11px 16px", fontSize: 13, fontWeight: 700, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {showBullView && bullToday != null ? (<>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><CSIcon name="chart" size={14} />오늘 시장이 내 BULL에</span>
              <span className="num" style={{ color: bullToday >= 0 ? "var(--cs-rise)" : "var(--cs-fall)" }}>
                {bullToday >= 0 ? '+' : '-'}<RollingNumber text={Math.round(Math.abs(bullToday)).toLocaleString('ko-KR')} /> BULL
              </span>
            </>) : (<>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><CSIcon name="chart" size={14} />오늘 시장이 내 자산에</span>
              <span className="num" style={{ color: "var(--cs-income)" }}>+320,000 예상</span>
            </>)}
          </div>
          {/* 봇 뉴스 — 커뮤니티 최신 봇글 연동 (없으면 폴백) */}
          {botPost ? (
            <div onClick={() => nav(`/community/post/${botPost.id}`)} style={{ display: "flex", gap: 16, paddingTop: 16, boxShadow: "inset 0 1px 0 var(--cs-line)", cursor: "pointer" }}>
              <BotAuthorAvatar persona={botPost.author_bot_persona} author={botPost.author} size={36} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 800, lineHeight: 1.4 }}>{botPost.title}</div>
                <div style={{ fontSize: 11, color: "var(--cs-ink-2)", lineHeight: 1.5, marginTop: 3, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{homeExcerpt(botPost.content)}</div>
                <div style={{ fontSize: 10, color: "var(--cs-mute)", marginTop: 5 }}>{formatPostDate(botPost.created_at, new Date())} · {botPost.author} · <span style={{ color: "var(--cs-accent)" }}>더보기</span></div>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 16, paddingTop: 16, boxShadow: "inset 0 1px 0 var(--cs-line)" }}>
              <CastAvatar id="bbiyong" size={36} style={{ flexShrink: 0 }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 800, lineHeight: 1.4 }}>아직 봇 브리핑이 없어요</div>
                <div style={{ fontSize: 11, color: "var(--cs-ink-2)", lineHeight: 1.5, marginTop: 3 }}>곧 황둥이·삐용이가 시황을 정리해 올려요.</div>
                <div style={{ fontSize: 10, color: "var(--cs-mute)", marginTop: 5 }}>커뮤니티 · 시황 브리핑</div>
              </div>
            </div>
          )}
        </CSCard>

        {/* ③-2 거시 이벤트방 — 금리 예측 투표 (활성 이벤트 있을 때만 · 토글 OFF면 숨김) */}
        {macroPrimary && (
          <>
            <SectH title={<>금리 예측 투표</>} link="→" onLink={() => nav('/macro-event')} />
            <CSCard padded onClick={() => nav(`/macro-event/${macroPrimary.id}`)} style={{ marginBottom: 16, cursor: "pointer" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <CastAvatar id="hwangdoongi" size={40} style={{ flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13.5, fontWeight: 800, color: "var(--cs-ink)" }}>{macroPrimary.title}</div>
                  <div style={{ fontSize: 11.5, color: "var(--cs-mute)", marginTop: 2 }}>
                    {(() => {
                      const t = (macroPrimary.dist?.hike || 0) + (macroPrimary.dist?.hold || 0) + (macroPrimary.dist?.cut || 0);
                      if (macroPrimary.status === 'resolved') return `결과 발표 · ${t}명 참여`;
                      if (macroPrimary.status === 'locked') return '투표 마감 · 결과 대기 중';
                      return `${t}명 예측 중 · 맞히면 🔔 배지`;
                    })()}
                  </div>
                </div>
                <span style={{ fontSize: 11, fontWeight: 800, color: macroPrimary.my_pick ? "var(--cs-accent)" : "var(--cs-gold)", boxShadow: `inset 0 0 0 1px ${macroPrimary.my_pick ? "var(--cs-accent)" : "var(--cs-gold)"}`, borderRadius: 999, padding: "3px 10px", flexShrink: 0 }}>
                  {macroPrimary.my_pick ? '예측함' : '예측하기'}
                </span>
              </div>
            </CSCard>
          </>
        )}

        {/* (게임탭→모의투자 전환으로 "오늘의 한 수" O/X 예측 게임 제거 — 2026-06-09) */}

        {popularIndicator && <IndicatorGalleryCard variant="home" item={popularIndicator} onBrowse={() => nav('/community')} onClick={() => nav(`/community/indicator/${popularIndicator.version_id}`)} />}

        {/* ④ 콘텐츠 — 커뮤 뜨는 글 */}
        <SectH title={<>커뮤니티 지금 뜨는 글</>} link="→" />
        <CSCard padded style={{ marginBottom: 16 }}>
          {[
            { e: "🔥", t: '"엔비디아 존버 280일차, 드디어…"', m: "💬 142" },
            { e: "📈", t: '"이 종목 지금 사도 될까요?"', m: "💬 88" },
            { e: "💸", t: '"이번 달 월급 명세서 공개합니다"', m: "💬 56" },
          ].map((p, i, arr) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: i < arr.length - 1 ? "1px solid var(--cs-line)" : "none" }}>
              <div style={{ fontSize: 13 }}>{p.e} <b style={{ fontWeight: 700 }}>{p.t}</b></div>
              <div style={{ fontSize: 11, color: "var(--cs-mute)", flexShrink: 0, marginLeft: 10 }}>{p.m}</div>
            </div>
          ))}
        </CSCard>

        {/* 실패 박물관 — 가로 카드 (캐릭터 판결) */}
        <SectH title={<>실패 박물관</>} link="→" onLink={() => nav('/failmuseum')} />
        <div style={{ display: "flex", gap: 10, overflowX: "auto", marginBottom: 16 }}>
          {[
            { tag: "#불타기실패", ttl: "에코프로 150층 구조대 대기 중…", likes: "👍 128", judge: "hwangdoongi", judgeName: "황둥이" },
            { tag: "#충동구매", ttl: "새벽 3시 감성 안마의자 결제", likes: "👍 94", judge: "yeouni", judgeName: "여우니" },
            { tag: "#영끌", ttl: "고점에 영끌, 지금은 반토막", likes: "👍 71" },
          ].map((f, i) => (
            // 카드 내용 = 타인 자랑글 형식 → 목적지도 자랑 홀로 (미끼·도착지 부정합 fix, UX 검수 #4. mock 콘텐츠 교체는 콜드스타트 큐레이션과 함께)
            <div key={i} onClick={() => nav('/failmuseum/brag')} style={{ flex: "0 0 180px", background: "var(--cs-surface-2)", borderRadius: 12, padding: 12, cursor: "pointer" }}>
              <div style={{ fontSize: 9.5, fontWeight: 800, color: "var(--cs-rise)" }}>{f.tag}</div>
              <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.4, margin: "4px 0 8px", minHeight: 36 }}>{f.ttl}</div>
              <div style={{ fontSize: 11, color: "var(--cs-mute)", display: "flex", alignItems: "center", gap: 4 }}>
                {f.likes}{f.judge && <> · <CastAvatar id={f.judge} size={20} style={{ flexShrink: 0 }} /> {f.judgeName} 판결</>}
              </div>
            </div>
          ))}
        </div>

        {/* (게임탭→모의투자 전환으로 게임·토토 타일 제거 — 나머지 게임 완전 보류, 2026-06-09) */}

        {/* 인생 시뮬 배너 — 히어로 티저(:532)와 동일하게 /play 자산시뮬 진입 (onClick 부재 dead-end fix 2026-07-02) */}
        <div onClick={() => nav('/play')} style={{ background: "var(--cs-gold-soft)", borderRadius: 16, padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><CSIcon name="home" size={14} />자산 시뮬레이션 — 10년 후 내 자산은?</span>
          <span style={{ color: "var(--cs-gold)" }}>해보기 →</span>
        </div>

        <HomeFooter />
      </div>
    </div>
  );
}
